import React, { useEffect, useState, Children } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
const navLinks = [{
  name: 'Home',
  href: '#home'
}, {
  name: 'My Journey',
  href: '#journey'
}, {
  name: 'Career Path',
  href: '#career'
}, {
  name: 'Journeys',
  href: '#travel'
}, {
  name: 'Emotion Picker',
  href: '#mood'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const menuVariants = {
    closed: {
      opacity: 0,
      x: '100%',
      transition: {
        type: 'spring',
        stiffness: 400,
        damping: 40
      }
    },
    open: {
      opacity: 1,
      x: 0,
      transition: {
        type: 'spring',
        stiffness: 400,
        damping: 40,
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    closed: {
      opacity: 0,
      x: 50
    },
    open: {
      opacity: 1,
      x: 0
    }
  };
  return <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'glass-nav py-4' : 'bg-transparent py-6'}`} data-id="element-86">
        <div className="max-w-7xl mx-auto px-6 flex justify-between items-center" data-id="element-87">
          <a href="#" className="text-3xl font-moon-dance font-bold text-zen-text z-50 relative" data-id="element-88">
            Explore with Anjali
          </a>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-89">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-zen-text/80 hover:text-zen-accent transition-colors duration-300 text-sm tracking-wide font-medium" data-id="element-90">
                {link.name}
              </a>)}
            <button className="px-6 py-2 bg-zen-text text-white rounded-full text-sm hover:bg-zen-accent transition-colors duration-300" data-id="element-91">
              Let's Talk
            </button>
          </div>

          {/* Mobile Toggle */}
          <button className="md:hidden z-50 relative p-2 text-zen-text" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-92">
            {isOpen ? <X size={24} data-id="element-93" /> : <Menu size={24} data-id="element-94" />}
          </button>
        </div>
      </nav>

      {/* Mobile Overlay */}
      <AnimatePresence data-id="element-95">
        {isOpen && <motion.div initial="closed" animate="open" exit="closed" variants={menuVariants} className="fixed inset-0 bg-zen-bg z-40 flex flex-col justify-center items-center md:hidden" data-id="element-96">
            <div className="flex flex-col space-y-8 text-center" data-id="element-97">
              {navLinks.map(link => <motion.a key={link.name} href={link.href} variants={itemVariants} onClick={() => setIsOpen(false)} className="text-4xl font-moon-dance text-zen-text hover:text-zen-accent transition-colors" data-id="element-98">
                  {link.name}
                </motion.a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}